import { MapPin } from "lucide-react";

const TOWNS = [
  "Hiawatha",
  "Horton",
  "Sabetha",
  "Fairview",
  "Powhattan",
  "Morrill",
  "Robinson",
  "Reserve",
  "Everest",
  "Highland",
  "White Cloud",
];

export default function ServiceArea() {
  return (
    <section id="areas" data-testid="service-area-section" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <div className="text-xs font-semibold uppercase tracking-widest text-[#E31837] mb-3">
              Where we work
            </div>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900">
              Proudly serving Northeast Kansas.
            </h2>
            <p className="mt-5 text-lg text-slate-600 leading-relaxed">
              Based in Hiawatha, we provide residential and commercial HVAC service across Brown
              County and surrounding communities. Don't see your town? Give us a call — chances
              are we cover it.
            </p>

            <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 gap-2">
              {TOWNS.map((t) => (
                <div
                  key={t}
                  data-testid={`town-${t.toLowerCase()}`}
                  className="flex items-center gap-2 px-4 py-3 rounded-2xl bg-slate-50 border border-slate-100 hover:border-[#E31837] hover:bg-white transition-colors"
                >
                  <MapPin className="w-4 h-4 text-[#E31837]" />
                  <span className="text-sm font-medium text-slate-700">{t}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative rounded-3xl overflow-hidden border border-slate-100 shadow-xl bg-slate-100 aspect-[4/3]">
            <iframe
              title="Koehn Cooling location"
              data-testid="service-area-map"
              src="https://www.google.com/maps?q=1913+Iowa+Street,+Hiawatha,+KS+66434&output=embed"
              loading="lazy"
              className="w-full h-full border-0"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
